import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {
  AppErrorsInterceptor,
  CredentialsInterceptor,
  PollingInterceptor,
  TraceInterceptor,
} from './interceptors';

/**
 * App http interceptors
 */
export const APP_HTTP_INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CredentialsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: PollingInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AppErrorsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TraceInterceptor,
    multi: true,
  },
];
